// Thandi House Parallax Effect
(function() {
    'use strict';

    // Wait for everything to be loaded
    window.addEventListener('load', function() {
        // Get the parallax element
        var parallaxElement = document.getElementById('main_entrance_holder');
        
        // Only run if the parallax element exists
        if (parallaxElement) {
            // Set initial position
            var elementRect = parallaxElement.getBoundingClientRect();
            var initialPosition = elementRect.top + window.pageYOffset;
            var elementHeight = parallaxElement.offsetHeight;
            var ticking = false;
            
            // Set initial position explicitly
            parallaxElement.style.backgroundPosition = 'center 100%';
            
            // Throttle function to improve performance
            function throttle(callback, limit) {
                var wait = false;
                return function() {
                    if (!wait) {
                        callback.apply(null, arguments);
                        wait = true;
                        setTimeout(function() {
                            wait = false;
                        }, limit);
                    }
                };
            }
            
            // Parallax effect function
            function updateParallax() {
                // Only run if we're not already ticking
                if (!ticking) {
                    window.requestAnimationFrame(function() {
                        // Calculate the scrolled distance
                        var scrolled = window.pageYOffset || document.documentElement.scrollTop;
                        
                        // Calculate the background position
                        // Start from bottom (100%) and adjust based on scroll
                        var yOffset = scrolled * 0.2; // Reduced multiplier for subtler effect
                        
                        // Apply the effect with smooth transition
                        parallaxElement.style.backgroundPosition = 'center calc(100% + ' + yOffset + 'px)';
                        parallaxElement.style.transition = 'background-position 0.1s ease-out';
                        
                        ticking = false;
                    });
                    
                    ticking = true;
                }
            }
            
            // Create throttled version of updateParallax
            var throttledParallax = throttle(updateParallax, 10);
            
            // Handle window resize
            function handleResize() {
                elementRect = parallaxElement.getBoundingClientRect();
                initialPosition = elementRect.top + window.pageYOffset;
                elementHeight = parallaxElement.offsetHeight;
                throttledParallax();
            }
            
            // Add event listeners
            window.addEventListener('scroll', throttledParallax, { passive: true });
            window.addEventListener('resize', throttle(handleResize, 100));
            
            // Initial call after a small delay to ensure everything is ready
            setTimeout(function() {
                parallaxElement.style.backgroundPosition = 'center 100%';
                throttledParallax();
            }, 50);
        }
    });
})();
